import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef, OnChanges, SimpleChanges, ElementRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { startWith, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { MatSelectionList } from '@angular/material/list';
import { DOWN_ARROW, TAB } from '@angular/cdk/keycodes';
import { MatExpansionPanel } from '@angular/material/expansion';
import { isNullOrEmpty } from '@awp/core/utils';
import { DestinationType } from '../destination-select/destination-select.component';
var TravelDestinationDialogComponent = /** @class */ (function () {
    function TravelDestinationDialogComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.DestinationType = DestinationType;
        this.formSearchControl = new FormControl();
        this.isFilterActive = false;
        this.places = [];
        this.popularList = [];
        this.selectedValues = [];
        this.isPanelExpanded = false;
        this.destinations = [];
        this.selected = [];
        this.groupLimit = 3;
    }
    TravelDestinationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formSearchControl.valueChanges.pipe(startWith(null), debounceTime(300), distinctUntilChanged(), map(function (value) {
            _this.isFilterActive = !isNullOrEmpty(value);
            if (_this.isPanelExpanded && _this.isFilterActive) {
                _this.expansionPanel.close();
            }
            if (_this.isFilterActive) {
                return _this.applyFilter(value).sort(_this.sortList);
            }
            else {
                return _this.applyPopularFilter().sort(_this.sortList);
            }
        }), untilDestroyed(this))
            .subscribe(function (destinations) {
            _this.places = destinations;
            _this.changeDetectorRef.markForCheck();
        });
    };
    TravelDestinationDialogComponent.prototype.ngOnChanges = function (changes) {
        if (changes.destinations != null && changes.destinations.currentValue) {
            this.popularList = this.buildPopularList(changes.destinations.currentValue);
            this.formSearchControl.updateValueAndValidity();
        }
        if (changes.selected != null) {
            this.selectedValues = changes.selected.currentValue || [];
        }
        if (changes.showSelected != null) {
            this.isPanelExpanded = changes.showSelected.currentValue;
        }
    };
    TravelDestinationDialogComponent.prototype.ngOnDestroy = function () { };
    TravelDestinationDialogComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.isPanelExpanded) {
            setTimeout(function () {
                _this.expansionPanel.open();
                _this.clearInput();
            }, 500);
        }
    };
    TravelDestinationDialogComponent.prototype.optionSelected = function (event) {
        if (event.option.value != null) {
            this.add(event.option.value);
        }
        if (this.isFilterActive) {
            this.clearInput();
            this.input.nativeElement.focus();
        }
        else {
            this.places = this.applyPopularFilter().sort(this.sortList);
        }
        this.changeDetectorRef.markForCheck();
    };
    TravelDestinationDialogComponent.prototype.clearInput = function () {
        this.input.nativeElement.value = '';
        this.formSearchControl.setValue(null);
    };
    TravelDestinationDialogComponent.prototype.add = function (value) {
        if (value == null) {
            return;
        }
        if (this.selectedValues == null) {
            this.selectedValues = [value];
        }
        else if (!this.selectedValues.includes(value)) {
            this.selectedValues = tslib_1.__spread(this.selectedValues, [value]);
        }
        this.changeDetectorRef.markForCheck();
    };
    TravelDestinationDialogComponent.prototype.remove = function (item) {
        var values = tslib_1.__spread(this.selectedValues);
        var index = values.indexOf(item);
        if (index >= 0) {
            values.splice(index, 1);
            this.selectedValues = values;
        }
        if (this.selectedValues.length === 0) {
            this.panelCollapse();
        }
        this.changeDetectorRef.markForCheck();
    };
    TravelDestinationDialogComponent.prototype.isSelected = function (destination) {
        return this.selectedValues != null ? this.selectedValues.indexOf(destination) >= 0 : false;
    };
    TravelDestinationDialogComponent.prototype.destinationText = function () {
        return this.selectedValues != null && this.selectedValues.length > 0
            ? (this.selectedValues[0].name) + " + " + (this.selectedValues.length - 1) + " destinations "
            : 'None selected';
    };
    TravelDestinationDialogComponent.prototype.panelExpanded = function () {
        this.isPanelExpanded = true;
        this.clearInput();
    };
    TravelDestinationDialogComponent.prototype.panelCollapse = function () {
        this.isPanelExpanded = false;
    };
    TravelDestinationDialogComponent.prototype.onInputKeyboardNavigation = function (event) {
        if (event.keyCode === DOWN_ARROW) {
            this.selectionList.options.first.focus();
        }
    };
    TravelDestinationDialogComponent.prototype.onListKeyboardNavigation = function (event) {
        if (event.keyCode === TAB) {
            this.input.nativeElement.focus();
        }
    };
    TravelDestinationDialogComponent.prototype.getSelectedIds = function () {
        return this.selectedValues != null ? this.selectedValues.map(function (p) { return p.id; }) : [];
    };
    TravelDestinationDialogComponent.prototype.applyFilter = function (value) {
        var filterValue = value.toLowerCase();
        var selectedIds = this.getSelectedIds();
        return this.destinations.filter(function (p) { return !selectedIds.includes(p.id) // Remove current selection
            && p.destinationType !== DestinationType.Region // exclude regions
            && p.searchName.indexOf(filterValue) === 0; });
    };
    TravelDestinationDialogComponent.prototype.applyPopularFilter = function () {
        if (this.popularList == null || this.popularList.length === 0)
            return [];
        var selectedIds = this.getSelectedIds();
        var result = this.popularList.filter(function (p) { return !selectedIds.includes(p.id); }); // Remove current selection
        var regions = new Set(result.map(function (p) { return p.destinationType !== DestinationType.Region ? p.regionId : null; }).filter(function (p) { return p != null; })); // Get Regions
        // filter regions that do not have any countries
        result = result.filter(function (p) {
            if (p.destinationType === DestinationType.Region) {
                return regions.has(p.id);
            }
            return true;
        });
        return result;
    };
    TravelDestinationDialogComponent.prototype.buildPopularList = function (values) {
        var clonedList = values.map(function (p) { return (tslib_1.__assign({}, p)); });
        var regionList = clonedList.filter(function (p) { return p.destinationType === DestinationType.Region; });
        regionList.forEach(function (region) {
            region.sortOrder = region.sortOrder * 1000;
            var index = region.sortOrder + 1;
            var countryList = clonedList.filter(function (p) { return p.regionId === region.id; }).sort(function (a, b) { return a.searchName.localeCompare(b.searchName); });
            countryList.forEach(function (country) {
                country.sortOrder = index;
                index++;
            });
        });
        return clonedList.filter(function (p) { return p.isPopular; });
    };
    TravelDestinationDialogComponent.prototype.sortList = function (a, b) { return (a.sortOrder < b.sortOrder) ? -1 : (a.sortOrder > b.sortOrder) ? 1 : 0; };
    return TravelDestinationDialogComponent;
}());
export { TravelDestinationDialogComponent };
